var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTtimNameIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 608.73,
    height: 200,
    viewBox: "0 0 608.73 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M90.32,94.16V-56.369h52.646V-88.115H1.96v31.746H54.341V94.16Zm149.206,0V-56.369h52.646V-88.115H151.166v31.746h52.381V94.16Zm90.212-153.7c12.7,0,23.545-10.582,23.545-23.016,0-12.7-10.847-23.28-23.545-23.28a23.308,23.308,0,0,0-23.28,23.28A23.086,23.086,0,0,0,329.738-59.544ZM347.2,94.16V-39.173H312.807V94.16Zm205.82-137.3c-21.429,0-38.1,8.73-47.619,23.016-8.466-14.55-23.81-23.016-44.974-23.016-19.841,0-35.45,7.407-44.18,21.164v-17.2H381.854V94.16h34.392V24.848c0-22.487,12.434-37.3,33.333-37.3,18.519,0,29.63,11.9,29.63,32.011v74.6h34.127V24.319c0-21.958,12.7-36.508,33.333-36.508,18.783,0,29.63,12.169,29.63,32.275V94.16H610.69V12.679C610.69-20.655,589-43.142,553.018-43.142Z",
    transform: "translate(-1.96 105.84)",
    fill: "#1d0b77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtimNameIcon);
export default __webpack_public_path__ + "static/media/ttim_name_icon.de8c02daf8d533128d70f394b31783d2.svg";
export { ForwardRef as ReactComponent };